import { createRouter, createWebHistory } from 'vue-router'
import { guardedRoutes } from './guardedRoutes'

let routes = [
  {
    path: '/',
    name: 'Root',
    component: () => import('@/views/public/home/Home.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/public/home/Home.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/public/user-account/Login.vue')
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import('@/views/public/signup/Index.vue')
  },
  {
    path: '/verification',
    name: 'Verification',
    component: () => import('@/views/public/signup/Verification.vue')
  },
  {
    path: '/forget-password',
    name: 'Forget Password',
    component: () => import('@/views/public/user-account/ForgetPassword.vue')
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    component: () => import('@/views/public/user-account/ResetPassword.vue')
  },
  {
    path: '/account-verified',
    name: 'Verified',
    component: () => import('@/views/public/user-account/Verified.vue')
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: () => import('@/views/public/privacy-policy/Index.vue')
  },
  {
    path: '/faq',
    name: 'About',
    component: () => import('@/views/public/About.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: () => import('@/views/error/404.vue')
  }
]
routes = routes.concat(guardedRoutes)
const router = createRouter({
  routes,
  history: createWebHistory(),
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        top: 140
      }
    }
    return { top: 0 }
  }
})

export default router
